import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    actionsButtonsState,
    currentMaxZoomState,
    isCanAccessMapTileLayerState,
    isHideMapTilesState,
    mapTileUrlState,
} from '../../../../app/redux/retrievers/retrievers';
import { TileLayer, useMap, WMSTileLayer, LayerGroup, LayersControl } from 'react-leaflet';
import { mapTileUrlList } from './mapTileUrlList';
import { sendDataToParent } from '../../base/functions/sendDataToParent';
import { currentTileLayerMessageSetter } from './functions/currentTileLayerMessageSetter';
import { maxZoomSetter } from './functions/maxZoomSetter';
import BingLayer from './BingLayer';

import 'leaflet-bing-layer';
import OverlaysController from './Overlays/OverlaysController';

const TilesLayer = () => {
    const map = useMap();
    const dispatch = useDispatch();
    const mapTileUrl = useSelector(mapTileUrlState);
    const currentMaxZoom = useSelector(currentMaxZoomState);
    const isHideMapTiles = useSelector(isHideMapTilesState);
    const isCanAccessMapTileLayer = useSelector(isCanAccessMapTileLayerState);

    const [tileLayerKey, setTileLayerKey] = useState(0);

    useEffect(() => {
        maxZoomSetter(dispatch, mapTileUrl);
    }, [mapTileUrl]);

    useEffect(() => {
        if (isCanAccessMapTileLayer) {
            const currentTileLayerMessage = currentTileLayerMessageSetter(mapTileUrl);
            if (currentTileLayerMessage != undefined) {
                sendDataToParent({
                    type: 'current-tile-layer',
                    currentTileLayer: currentTileLayerMessage,
                });
            }
        }
    }, [mapTileUrl, isCanAccessMapTileLayer]);

    useEffect(() => {
        setTileLayerKey(tileLayerKey + 1 * Math.random());
    }, [mapTileUrl]);

    return (
        <>
            {!isHideMapTiles && <TileLayer key={tileLayerKey} url={mapTileUrl} maxZoom={currentMaxZoom} />}
            <BingLayer map={map} mapTileUrl={mapTileUrl} isHideMapTiles={isHideMapTiles} />
            {/* <WMSTileLayer
                url="https://gibs-c.earthdata.nasa.gov/wmts/epsg4326/best/wmts.cgi?TIME=2023-01-17T00:00:00Z&layer=MODIS_Combined_L4_LAI_4Day&style=default&tilematrixset=500m&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix={z}&TileCol={x}&TileRow={y}"
                layers="VIIRS_NOAA20_Thermal_Anomalies_375m_All"
                format="image/png"
                transparent={true}
                version="1.1.1"
                // time="2020-10-01T00:00:00Z"
                styles=""
                attribution='&copy; <a href="https://earthdata.nasa.gov">NASA EOSDIS</a>'
            /> */}

            {/* <OverlaysController
                tileLayerKey={tileLayerKey}
                mapTileUrl={mapTileUrl}
                mapTileUrlList={mapTileUrlList}
                currentMaxZoom={currentMaxZoom}
            /> */}
        </>
    );
};

export default TilesLayer;
